<app-admin-page-section titleT="admin.reports.title">
    <div class="admin-action-item-list">

        <app-admin-action-item titleT="admin.reports.customer-space-report">
            <app-button-indicator-download [isPending]="customerSpaceReportPending.isPending()"
                (clicked)="downloadCustomerSpaceReport()" />
        </app-admin-action-item>

        <app-admin-action-item titleT="admin.reports.project-report">
            <app-button-indicator-download [isPending]="projectReportPending.isPending()"
                (clicked)="downloadProjectReport()" />
        </app-admin-action-item>

        <app-admin-action-item titleT="admin.reports.user-report">
            <app-button-indicator-download [isPending]="userReportPending.isPending()"
                (clicked)="downloadUserReport()" />
        </app-admin-action-item>

    </div>
</app-admin-page-section>